import React, {Component} from 'react';
import {AutoComplete} from "antd/lib/index";
import {get, post} from "../../../common/utils/http";
import {isEmpty} from "../../../common/utils/StringUtils";
import AisinoInput from "../input/AisinoInput";
import CloseCircleFilled from "@ant-design/icons/es/icons/CloseCircleFilled";
import {getLanguage} from "../../../source/js/common";

const commonLan = require('../../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

/**
 * @路兵虎
 * 传入参数
 * allowClear  ture为展示  false为不展示
 * oncloseclick()   点击清除后执行的方法  当清空按钮不展示的时候  这个方法也不会用到
 * url   str
 * params   {}
 * valueField   str
 * textField str  下拉框展示文字
 * post  bool  默认为get提交
 * minChar str|int  最低输入多少字符触发
 * onSelect()  选择下拉框后触发后传入选中的实体类
 * onvaluechanged() 修改后触发传入变动的文本
 */
class AisinoAutoComplete extends Component {
    state = {
        options: [],
        url: this.props.url,
        params: {key:""} ,
        post: this.props.post,
        valueField: this.props.valueField,
        textField: this.props.textField,
        timeStampClass: "aisino" + new Date().getTime(),
        minChar: isEmpty(this.props.minChar) ? 1 : this.props.minChar,
        inputValue:"",
        value:""
    };

    componentDidMount() {
        //document.getElementsByClassName(this.state.timeStampClass).addEventListener()
        if(!isEmpty(this.props.params)){
            this.setState({
                params:{...this.state.params,...this.props.params}
            })
        }
    }

    componentWillReceiveProps(nextProps) {

        if(nextProps.value!=undefined){
            this.setState({
                inputValue:nextProps.value
            });
        }
        if(!isEmpty(nextProps.params)){
            this.setState({
                params: nextProps.params
            });
        }
        return false;
    }

    async clear(){
        this.setState({
            inputValue:"",
            options:[],
        });
        if (!isEmpty(this.props.oncloseclick)){
            this.props.oncloseclick()
        }

    }

    async onSelectEvent(value) {
        this.setState({
            inputValue:value
        });
        const opt=this.state.options.find((e) => e.value== value);
        if(!isEmpty(this.props.onSelect)){
            this.props.onSelect(opt.key)
        }
        const params = this.state.params;
        params.key = value;
        await this.loadDate(params);
    }


    async onSearch(value) {
        if (isEmpty(value) || value.length < this.props.minChar) {
            return;
        }
        const params = this.state.params;
        params.key = value;
        await this.loadDate(params);
        if (!isEmpty(this.props.onvaluechanged)) {
            this.props.onvaluechanged(value)
        }
    }
    async loadDate(params) {
        let res;
        if (this.state.post) {
            res = await post(this.props.url, params);
        } else {
            res = await get(this.props.url, params);
        }
        if(isEmpty(res)){
            return;
        }
        const options = res.map(e => {
            return {
                key: e[this.state.valueField],
                value: e[this.state.textField]
            }
        });
        this.setState({
            options: options
        })
    }

    inputChange(e){
        if(e.target.value === ""){
            this.clear()
        }
        this.setState({
            inputValue:e.target.value
        })
    }
    getRef(){
        return this.refs.autoComplete;
    }
    render() {
        const {onSelect,name,...ps}=this.props;
        return (
            <div>
                <AutoComplete ref={"autoComplete"} value={this.state.inputValue} {...ps} allowClear={false}//使用自己封装的清除
                              options={this.state.options}
                              onSelect={this.onSelectEvent.bind(this)}
                              onSearch={this.onSearch.bind(this)}
                              placeholder={commonLan.pleaseSelect.label}

                >
                    <AisinoInput style={ps.style} onChange={this.inputChange.bind(this)} name={name}/>
                </AutoComplete>
                    <span 
                    onClick={this.clear.bind(this)} 
                    style={{marginTop:"10px"}} 
                    className={["anticon anticon-close-circle ant-input-textarea-clear-icon ",
                                this.props.allowClear?isEmpty(this.state.inputValue)?" hide ":" ":" ",
                                ps.disabled?" hide ":" "
                                ].join(" ")}>
                        <CloseCircleFilled />
                    </span>
            </div>
        );
    }
}

export default AisinoAutoComplete;
